/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { 
  AD, AE, AF, AG, AL, AM, AO, AR, AT, AU, AZ, BA, BB, BD, BE, BF, BG, BH, BI, BJ, BN, BO, BR, BS,
  BT, BW, BY, BZ, CA, CD, CF, CG, CH, CI, CL, CM, CN, CO, CR, CU, CV, CY, CZ, DE, DJ, DK, DM, DO,
  DZ, EC, EE, EG, ER, ES, ET, FI, FJ, FM, FR, GA, GB, GD, GE, GH, GL, GM, GN, GP, GQ, GR, GT, GU,
  GW, GY, HK, HN, HR, HT, HU, ID, IE, IL, IN, IQ, IR, IS, IT, JM, JO, JP, KE, KG, KH, KI, KM, KN,
  KP, KR, KW, KZ, LA, LB, LC, LI, LK, LR, LS, LT, LU, LV, LY, MA, MC, MD, ME, MG, MH, MK, ML, MM,
  MN, MR, MT, MU, MV, MX, MY, MZ, NA, NE, NG, NI, NL, NO, NP, NR, NZ, OM, PA, PE, PG, PH, PK, PL,
  PR, PT, PW, PY, QA, RO, RS, RU, RW, SA, SB, SC, SD, SE, SG, SI, SK, SL, SM, SN, SO, SR, SS, ST,
  SV, SY, SZ, TD, TG, TH, TJ, TL, TM, TN, TO, TR, TT, TV, TW, TZ, UA, UG, US, UY, UZ, VC, VE, VN,
  VU, WS, YE, ZA, ZM, ZW
} from "country-flag-icons/react/3x2";

const countryConfig = {
  "Afghanistan": { flag: AF },
  "Albania": { flag: AL },
  "Algeria": { flag: DZ },
  "Andorra": { flag: AD },
  "Angola": { flag: AO },
  "Antigua": { flag: AG },
//  "Antigua": { flag: AG },
  "Argentina": { flag: AR },
  "Armenia": { flag: AM },
  "Australia": { flag: AU },
  "Austria": { flag: AT, gdpr: true },
  "Azerbaijan": { flag: AZ },
  "Bahamas": { flag: BS },
  "Bahrain": { flag: BH },
  "Bangladesh": { flag: BD },
  "Barbados": { flag: BB },
  "Belarus": { flag: BY },
  "Belgium": { flag: BE, gdpr: true },
  "Belize": { flag: BZ },
  "Benin": { flag: BJ },
//  "Bermuda": { flag: BM },
  "Bhutan": { flag: BT },
  "Bolivia": { flag: BO },
  "Bosnia Herzegovina": { flag: BA },
  "Botswana": { flag: BW },
  "Brazil": { flag: BR },
  "Brunei": { flag: BN },
  "Bulgaria": { flag: BG, gdpr: true },
  "Burkina": { flag: BF },
  "Burundi": { flag: BI },
  "Cambodia": { flag: KH },
  "Cameroon": { flag: CM },
  "Canada": { flag: CA },
  "Cape Verde": { flag: CV },
//  "Cayman Islands": { flag: KY },
  "Central African Rep": { flag: CF },
  "Chad": { flag: TD },
  "Chile": { flag: CL },
  "China": { flag: CN },
  "Colombia": { flag: CO },
  "Comoros": { flag: KM },
  "Congo": { flag: CG },
  "Congo (Democratic Rep)": { flag: CD },
  "Costa Rica": { flag: CR },
  "Croatia": { flag: HR, gdpr: true },
  "Cuba": { flag: CU },
//  "Curacao": { flag: CW },
  "Cyprus": { flag: CY, gdpr: true },
  "Czech Republic": { flag: CZ, gdpr: true },
  "Denmark": { flag: DK, gdpr: true },
  "Djibouti": { flag: DJ },
  "Dominica": { flag: DM },
  "Dominican Republic": { flag: DO },
  "East Timor": { flag: TL },
  "Ecuador": { flag: EC },
  "Egypt": { flag: EG },
  "El Salvador": { flag: SV },
  "Equatorial Guinea": { flag: GQ },
  "Eritrea": { flag: ER },
  "Estonia": { flag: EE, gdpr: true },
//  "Eswatini": { flag: SZ },
  "Ethiopia": { flag: ET },
  "Fiji": { flag: FJ },
  "Finland": { flag: FI, gdpr: true },
  "France": { flag: FR, gdpr: true },
  "Gabon": { flag: GA },
  "Gambia": { flag: GM },
  "Georgia": { flag: GE },
  "Germany": { flag: DE, gdpr: true },
  "Ghana": { flag: GH },
//  "Gibraltar": { flag: GI },
  "Greece": { flag: GR, gdpr: true },
  "Greenland": { flag: GL },
  "Grenada": { flag: GD },
  "Guadeloupe": { flag: GP },
  "Guam": { flag: GU },
  "Guatemala": { flag: GT },
//  "Guernsey": { flag: GG },
  "Guinea": { flag: GN },
  "Guinea-Bissau": { flag: GW },
  "Guyana": { flag: GY },
  "Haiti": { flag: HT },
  "Honduras": { flag: HN },
  "Hong Kong": { flag: HK },
  "Hungary": { flag: HU, gdpr: true },
  "Iceland": { flag: IS },
  "India": { flag: IN },
  "Indonesia": { flag: ID },
  "Iran": { flag: IR },
  "Iraq": { flag: IQ },
  "Ireland (Republic)": { flag: IE, gdpr: true },
  "Israel": { flag: IL },
  "Italy": { flag: IT, gdpr: true },
  "Ivory Coast": { flag: CI },
  "Jamaica": { flag: JM },
  "Japan": { flag: JP },
//  "Jersey": { flag: JE },
  "Jordan": { flag: JO },
  "Kazakhstan": { flag: KZ },
  "Kenya": { flag: KE },
  "Kiribati": { flag: KI },
  "Korea North": { flag: KP },
  "Korea South": { flag: KR },
  "Kuwait": { flag: KW },
  "Kyrgyzstan": { flag: KG },
  "Laos": { flag: LA },
  "Latvia": { flag: LV, gdpr: true },
  "Lebanon": { flag: LB },
  "Lesotho": { flag: LS },
  "Liberia": { flag: LR },
  "Libya": { flag: LY },
  "Liechtenstein": { flag: LI },
  "Lithuania": { flag: LT, gdpr: true },
  "Luxembourg": { flag: LU, gdpr: true },
  "Macedonia": { flag: MK },
  "Madagascar": { flag: MG },
  "Malaysia": { flag: MY },
  "Maldives": { flag: MV },
  "Mali": { flag: ML },
  "Malta": { flag: MT, gdpr: true },
  "Marshall Islands": { flag: MH },
  "Mauritania": { flag: MR },
  "Mauritius": { flag: MU },
  "Mexico": { flag: MX },
  "Micronesia": { flag: FM },
  "Moldova": { flag: MD },
  "Monaco": { flag: MC },
  "Mongolia": { flag: MN },
  "Montenegro": { flag: ME },
  "Morocco": { flag: MA },
  "Mozambique": { flag: MZ },
  "Myanmar": { flag: MM },
  "Namibia": { flag: NA },
  "Nauru": { flag: NR },
  "Nepal": { flag: NP },
  "Netherlands": { flag: NL, gdpr: true },
  "New Zealand": { flag: NZ },
  "Nicaragua": { flag: NI },
  "Niger": { flag: NE },
  "Nigeria": { flag: NG },
  "Norway": { flag: NO },
  "Oman": { flag: OM },
  "Pakistan": { flag: PK },
  "Palau": { flag: PW },
//  "Palestine": { flag: PS },
  "Panama": { flag: PA },
  "Papua New Guinea": { flag: PG },
  "Paraguay": { flag: PY },
  "Peru": { flag: PE },
  "Philippines": { flag: PH },
  "Poland": { flag: PL, gdpr: true },
  "Portugal": { flag: PT, gdpr: true },
  "Puerto Rico": { flag: PR },
  "Qatar": { flag: QA },
  "Romania": { flag: RO, gdpr: true },
  "Russian Federation": { flag: RU },
  "Rwanda": { flag: RW },
  "St Kitts and Nevis": { flag: KN },
  "St Lucia": { flag: LC },
  "Saint Vincent & the Grenadines": { flag: VC },
  "Samoa": { flag: WS },
  "San Marino": { flag: SM },
  "Sao Tome & Principe": { flag: ST },
  "Saudi Arabia": { flag: SA },
  "Senegal": { flag: SN },
  "Serbia": { flag: RS },
  "Seychelles": { flag: SC },
  "Sierra Leone": { flag: SL },
  "Singapore": { flag: SG },
  "Slovakia": { flag: SK, gdpr: true },
  "Slovenia": { flag: SI, gdpr: true },
  "Solomon Islands": { flag: SB },
  "Somalia": { flag: SO },
  "South Africa": { flag: ZA },
  "South Sudan": { flag: SS },
  "Spain": { flag: ES, gdpr: true },
  "Sri Lanka": { flag: LK },
  "Sudan": { flag: SD },
  "Suriname": { flag: SR },
  "Swaziland": { flag: SZ },
  "Sweden": { flag: SE, gdpr: true },
  "Switzerland": { flag: CH },
  "Syria": { flag: SY },
  "Taiwan": { flag: TW },
  "Tajikistan": { flag: TJ },
  "Tanzania": { flag: TZ },
  "Thailand": { flag: TH },
  "Togo": { flag: TG },
  "Tonga": { flag: TO },
  "Trinidad & Tobago": { flag: TT },
  "Tunisia": { flag: TN },
  "Turkey": { flag: TR },
  "Turkmenistan": { flag: TM },
  "Tuvalu": { flag: TV },
  "Uganda": { flag: UG },
  "Ukraine": { flag: UA },
  "United Arab Emirates": { flag: AE },
  "United Kingdom": { flag: GB },
  "United States": { flag: US },
  "Uruguay": { flag: UY },
  "Uzbekistan": { flag: UZ },
  "Vanuatu": { flag: VU },
  "Venezuela": { flag: VE },
  "Vietnam": { flag: VN },
//  "Virgin Islands (British)": { flag: VG },
//  "Virgin Islands (U.S)": { flag: VI },
//  "Wallis and Futuna": { flag: WF },
//  "Western Sahara": { flag: EH },
  "Yemen": { flag: YE },
  "Zambia": { flag: ZM },
  "Zimbabwe": { flag: ZW },
};

const countryList = Object.keys(countryConfig);

export const gdprCompliant = (country) => {
  return countryConfig[country]?.gdpr ?? false;
};

export const CountryFlag = ({country, title, className, style}) => {
  // get flag element
  let Element = countryConfig[country]?.flag;

  // render if available
  return Element ? <Element title={title ?? country} className={className} style={style} /> : null;
};

export default countryList;
